export function isValidISODate(str) {
    if (typeof str !== "string")
        return false;
    const d = new Date(str);
    return !isNaN(d.valueOf()) && d.toISOString() === str;
}
